// <cart-reservation-timer> — urgency countdown shown at the top of the cart drawer.
// The deadline is stored in sessionStorage so it survives drawer re-renders (Section
// Rendering API) and page navigation within the session, and resets when the tab closes.
if (!customElements.get('cart-reservation-timer')) {
  const STORAGE_KEY = 'viragoCartReservationDeadline';

  class CartReservationTimer extends HTMLElement {
    connectedCallback() {
      this.display = this.querySelector('[data-timer-display]');
      if (!this.display) return;

      const minutes = parseInt(this.getAttribute('data-minutes'), 10) || 10;

      let deadline = parseInt(sessionStorage.getItem(STORAGE_KEY), 10);
      const now = Date.now();
      if (!deadline || Number.isNaN(deadline) || deadline <= now) {
        deadline = now + minutes * 60 * 1000;
        sessionStorage.setItem(STORAGE_KEY, String(deadline));
      }
      this.deadline = deadline;

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const remaining = Math.max(0, this.deadline - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const mm = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
      const ss = String(totalSeconds % 60).padStart(2, '0');
      this.display.textContent = `${mm}:${ss}`;

      if (remaining <= 0) {
        clearInterval(this.interval);
      }
    }
  }

  customElements.define('cart-reservation-timer', CartReservationTimer);
}
